<template>
    <div class="home">
        <div class="main-panel">
            <div class="content">
                <div class="pdf">
                    <p id="p">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                    <button class="btn" @click="downloadPDFku"> Download PDF</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import jsPDF from 'jspdf'
    import html2canvas from "html2canvas"

    export default {
        
        name: "pdf",
        data(){
            return{

            }
        },

        methods: {

            downloadPDFku() {
                let pdfName = "test";

                var doc = new jsPDF()

                var html = document.getElementById("p").innerHTML;

                doc.text(html, 10, 10)
                doc.save(pdfName + '.pdf')
            }

        },
    }


</script>